<template>
    <b-modal
      :visible="shown"
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      class="EditorModal"
      @hide="OnClose">
      <div slot="modal-header" class="px-2">
        <h4 v-if="!!project">Project: {{project.name}}</h4>
        <h4 v-else>Project Update</h4>
      </div>
      <div>
        <b-row class="my-1">
          <b-col md="3">
            <label for="project-name">Project Name:</label>
          </b-col>
          <b-col md="9">
            <b-form-input
              id="project-name"
              size="md"
              v-model="name"
              type="text"
              placeholder="Name"
              :state="!name ? false : null"
              required />
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3">
            <label for="project-description">Project Description:</label>
          </b-col>
          <b-col md="9">
            <b-form-textarea
              id="project-description"
              size="md"
              rows="3"
              v-model="description"
              placeholder="Description" />
          </b-col>
        </b-row>
      </div>

      <div slot="modal-footer" style="width: 100%">
        <div class="text-right">
          <b-button @click="OnClose" variant="outline" class="px-3" size="md">
            Cancel
          </b-button>

          <b-button
            variant="primary"
            class="px-5"
            @click="saveChanges"
            :disabled="isSaving"
            style="float: right">
            <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
            <span>Save&nbsp;</span>
          </b-button>

        </div>
      </div>

    </b-modal>
</template>
<script>
  import axios from "axios";
  import { fullURL } from "../../utils";
  import AgentsList from "../CustomReportsManager/AgentsList";
  import ProjectList from "../CustomReportsManager/ProjectList";
  import { updateProject } from "../../store/files";

  export default {
    name: 'ProjectUpdateModal',
    components: {},
    props: {
      project: Object,
      shown: Boolean
    },

    data() {
      return {
        name: (!!this.project) ? this.project.name : null,
        description: (!!this.project) ? this.project.description : null,
        isSaving: false
      }
    },
    methods:{
      OnClose(changed=false) {
        // this.shown = false;
        this.$emit('close', changed);
      },

      saveChanges() {
        this.isSaving = true;
        var data = {"name": this.name};
        if (!!this.description) {
          data["description"] = this.description;
        }
        
        this.$store.dispatch(updateProject(this.project.id, this.name, this.description))
          .then(() => {
            this.$emit('success');
          })
          .catch(console.log)
          .finally(() => {
            this.isSaving = false;
          });
      },
      
      
    }
  }
</script>

<style>
  @media (min-width: 1200px) {
    .EditorModal .modal-lg {
      max-width: 950px;
    }
  }
</style>
